import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container pdf_area_class" }
const _hoisted_2 = { class: "area_body" }
const _hoisted_3 = { class: "area_section" }
const _hoisted_4 = { class: "area_form" }
const _hoisted_5 = { class: "area_form_body" }
const _hoisted_6 = { class: "area_row" }
const _hoisted_7 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_8 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_9 = { class: "area_col_body" }
const _hoisted_10 = { class: "datepicker" }
const _hoisted_11 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_12 = { class: "area_col_body" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "area_row" }
const _hoisted_15 = {
  class: "area_col_row",
  style: {"flex-direction":"row"}
}
const _hoisted_16 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_17 = { class: "area_col_body" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = {
  class: "area_col",
  style: {"width":"50%","border-bottom":"0","border-right":"1px solid #d9d9d9"}
}
const _hoisted_20 = { class: "area_col_body" }
const _hoisted_21 = { class: "select-wrap" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "area_row" }
const _hoisted_24 = { class: "area_col_body" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "area_row" }
const _hoisted_27 = { class: "area_col_body" }
const _hoisted_28 = { class: "select-wrap" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "area_row" }
const _hoisted_31 = { class: "area_col_body" }
const _hoisted_32 = { class: "full" }
const _hoisted_33 = { class: "area_row" }
const _hoisted_34 = { class: "area_col_body textarea_wrap" }
const _hoisted_35 = { class: "full" }
const _hoisted_36 = ["textContent"]
const _hoisted_37 = { class: "area_row" }
const _hoisted_38 = { class: "area_col_body" }
const _hoisted_39 = { class: "select-wrap" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "area_form_foot" }
const _hoisted_42 = { class: "area_button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "area_title" }, [
          _createElementVNode("p", null, "민원")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "area_form_title" }, [
                _createElementVNode("p", null, "민원 세부내역")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "1. 작성일")
                      ], -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.data.createDate) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.createDate]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "2. 작성자")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.data.writer) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.writer]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "3. 문의자 이름")
                      ], -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.data.complainant) = $event))
                          }, null, 512), [
                            [_vModelText, $setup.state.data.complainant]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "area_col_head" }, [
                        _createElementVNode("label", { class: "starMark" }, "4. 문의자 구분")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.data.complainantType) = $event)),
                            class: "w250"
                          }, [
                            _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.complainantTypeList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: item.key
                              }, _toDisplayString(item.name), 9, _hoisted_22))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, $setup.state.data.complainantType]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "5. 문의자 연락처")
                  ], -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.data.phoneNum) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.phoneNum]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "6. 문의 유형")
                  ], -1)),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.data.type) = $event)),
                        class: "w250"
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.key
                          }, _toDisplayString(item.name), 9, _hoisted_29))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, $setup.state.data.type]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "7. 문의 제목")
                  ], -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.data.title) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.title]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", null, "8. 문의 내용")
                  ], -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.data.content) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.state.data.content]
                      ]),
                      _createElementVNode("p", {
                        textContent: _toDisplayString($setup.state.data.content)
                      }, null, 8, _hoisted_36)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "area_col_head" }, [
                    _createElementVNode("label", { class: "starMark" }, "9. 조치 결과")
                  ], -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.data.resultType) = $event)),
                        class: "w250"
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "선택해주세요.", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.resultTypeList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.key
                          }, _toDisplayString(item.name), 9, _hoisted_40))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, $setup.state.data.resultType]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.router.push({ name: 'complain' })))
                  }, "목록"),
                  ($setup.state.mode)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "active",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.confirmAdd && $setup.confirmAdd(...args)))
                      }, "등록"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "active",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.confirmModify && $setup.confirmModify(...args)))
                        }, "저장"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "danger",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
                        }, "삭제")
                      ], 64)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.reset && $setup.reset(...args)))
                  }, "초기화")
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          "is-full-page": true
        }))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          gubun: $setup.state.gubun,
          onClose: $setup.closeModal,
          onCallback: $setup.callbackModal
        }, null, 8, ["type", "title", "content", "gubun", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}